import log from '@/services/log';
import Icons from '@/icons'
import ctx from '@/services/ctx';
import config from "@/services/config";
import channel from "@/cqs/channel";
import * as queries from "@/cqs/queries";
import {isCardLinked, getDataForCardBack, checkAccess} from '@/services/storiesonboardrepository';


class AppMenuModule implements IBoardButtonsProvider, ICardBadgesProvider, ICardButtonsProvider {


    public getBoardButtons = async (t: ITrelloClient, opts:any) : Promise<Array<any>> => {
        var self = this;
        var buttons = [];
        try {
            var s = await config(t).get();
            var hasAccess = await checkAccess(t);
            if(hasAccess && s.isCompleted) {
                var btn = {
                    icon: {
                        dark: Icons.AppIcon,
                        light: Icons.AppIcon
                    },
                    text: "StoriesOnBoard",
                    callback: function(t2) {
                        self.showBoardMenuDropdown(t2, "StoriesOnBoard");
                    },
                    condition: "always"
                };
                buttons.push(<never>btn);
                return buttons;
            }
        }
        catch(e) {
            log.err(e);
        }
        return [];
     }


    public async getCardButtons(t: ITrelloClient, opts: any): Promise<any[]> {
        var buttons:Array<any> = [];
        var isReady = await ctx(t).getReady();
        var hasAccess = await checkAccess(t);
        if(hasAccess && isReady) {
            const isLinked = await isCardLinked(t, opts.context.card);
            if(isLinked){
                buttons.push(<never>
                {
                    icon: Icons.AppIcon,
                    text: 'StoriesOnBoard',
                    condition: 'always',
                    callback: async function(t2 : ITrelloClient) {
                        t2.popup({
                            url: '../views/cardmenu.html',
                            callback: (a) => {},
                            height: 40,
                            title: "StoriesOnBoard"
                        });   
                    }
                });
            }
        }
        
        return buttons;
    }


    public getCardBadges = async (t: ITrelloClient, opts:any) : Promise<Array<any>> => {
        var buttons = [];
        try {
            var hasAccess = await checkAccess(t);
            if (hasAccess) {
                var isLinked = await isCardLinked(t, opts.context.card);
                if(isLinked) {
                    var b = {
                        text: '',
                        icon: Icons.Synced.BadgeIcon,
                    };
                    buttons.push(<never>b);
                }
            }
        }
        catch(e) {
            log.err(e);
        }

        return buttons;
    }


    public showBoardMenuDropdown(t: ITrelloClient, title: string) {
        t.popup({
            url: '../views/boardmenu.html',
            callback: (a) => {},
            height: 40,
            title: title
        });
    }
}

export var appModule = new AppMenuModule();
export default appModule;
